import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)
// Moment
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.updateLocale('en', {
  weekdays : [
      "周日", "周一", "周二", "周三", "周四", "周五", "周六"
  ]
})
import { getLocalStorage, setLocalStorage } from '@/utils'

const state = {
	origin: 'hk-union00000002',
	apiKey: 'hk-union00000002',
	userToken: 'HKunioToken_flight',
	userInfo: 'HKunioUserInfo_flight',
	userCard: 'HKunioSUserCard_flight',
	phoneCallNumber: '02161368452',
	pageHash: 'HKunioPageHash_flight',
	location: getLocalStorage('city') ? JSON.parse(getLocalStorage('city')) : {
		cityName: '上海',
		cityEnglishName: 'SHANGHAI',
		cityCode: 'PVG,SHA,ZMY',
		areaCode: 'CN',
		id: '552',
		country: 'CHINA',
		countryName: '中国'
	},
	bmap: {},
	hotel: {},
	fetchLoading: false,
	defaultDate: getLocalStorage('pickDate') ? JSON.parse(getLocalStorage('pickDate')) : {
		startDate:  moment().format('YYYY-MM-DD'),
		endDate: moment().add(1, 'day').format('YYYY-MM-DD'),
		startWeekday: moment().format('dddd'),
		endWeekday: moment().add(1, 'day').format('dddd'),
		seletDays:1,
	},
	roomNumber: getLocalStorage('roomNumber') ? JSON.parse(getLocalStorage('roomNumber')) : {
		rooms: 1,
		adult: 1,
		child: 0
	},
	brandList: getLocalStorage('brand') ? JSON.parse(getLocalStorage('brand')) : [],
	hotelDetail: {},
	scrollTop: 0,
	cover: false,
	validateForm: {},
	keys: [],
	
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})


// WEBPACK FOOTER //
// ./src/store/index.js